import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import VendorDashboard from './Views/Vendor/VendorDashboard';
import Vendorsettings from './Views/Vendor/Vendorsettings';
import VendorRegistrationBG from './Views/Vendor/VendorRegistration/VendorRegistrationBG';
import VendorCouponsOffers from './Views/Vendor/VendorCouponsOffers';
import Menu from './Views/Vendor/Menu';
import Dashboard from './Views/Vendor/Dashboard';
import CloverConnect from './Views/Vendor/CloverConnect';
import { LoginRedirect } from './LoginRedirect';
import { AuthProvider } from './AuthProvider';
import { OrderProvider } from './ordersCount';
import Login from './auth/Login/Login';
import VendorEditprofile from './Views/Vendor/VendorEditProfile';
import VendorProfile from './Views/Vendor/VendorProfile';
import ChangePassword from './Views/Vendor/ChangePassword';
import BusinessHours from './Views/Vendor/BusinessHours';
import QRCodeGenerate from './Views/Vendor/QRCodeGenerate';
import PrinterSettings from './Views/Vendor/PrinterSettings';
import PaymentsList from './Views/Vendor/PaymentsList';
import VendorAnnouncements from './Views/Vendor/Announcements/VendorAnnouncements';
import AnnouncementForm from './Views/Vendor/Announcements/AnnouncementForm';

function Vendorrouter() {
    return (
        <div>
            <BrowserRouter>
                <AuthProvider>
                    <OrderProvider>
                        <Routes>
                            <Route path='/login' element={<Login/>}></Route>
                            <Route
                                path="/vendorkycregistration"
                                element={<VendorRegistrationBG></VendorRegistrationBG>}
                            ></Route>
                            <Route
                                path="/home"
                                element={<VendorDashboard></VendorDashboard>}
                            ></Route>
                            <Route path="/menu" element={<Menu></Menu>}></Route>
                            <Route path="/menu/updateItem/:id" element={<Menu />} />
                            <Route path="/clover-connect" element={<CloverConnect />} />
                            <Route path="/Orders" element={<Dashboard></Dashboard>}></Route>
                            <Route path="/payments" element={<PaymentsList></PaymentsList>}></Route>
                            <Route path="/announcements" element={<VendorAnnouncements />} />
                            <Route path="/announcements/create" element={<AnnouncementForm />} />
                            <Route path="/announcements/edit/:id" element={<AnnouncementForm />} />
                            <Route
                                path="/vendor-settings"
                                element={<Vendorsettings></Vendorsettings>}
                            ></Route>
                            <Route path="/edit-profile" element={<VendorEditprofile />} />
                            <Route path="/edit-vendor" element={<VendorProfile />} />
                            <Route path="/change-password" element={<ChangePassword />} />
                            <Route path="/business-hours" element={<BusinessHours />} />
                            <Route path="/qr-code" element={<QRCodeGenerate />} />
                            <Route path="/printer-settings" element={<PrinterSettings />} />
                            {/* <Route path='/switch-account' element={<Switchaccount/>} /> */}
                            {/* <Route path='SwithAccountBtns' element={<SwitchAccountBtns/>} /> */}
                            <Route
                                path="/VendorCouponsOffers"
                                element={<VendorCouponsOffers></VendorCouponsOffers>}
                            ></Route>
                           
                            <Route path="*" element={<LoginRedirect />} />
                        
                        </Routes>
                    </OrderProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default Vendorrouter;
